module.exports = __webpack_public_path__ + "static/media/sdg_icon_11.7255c859.png";